import { Box, Grid, Skeleton } from '@mui/material';
import React from 'react';
import Marquee from "react-easy-marquee";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
const Statistics = React.lazy(() => import("../Statistics")
  );
const StatisticsBox = ({phone}) => {
  const navigate = useNavigate()
    const news = useSelector(state => state.branches.news)
    const loadingNew = useSelector(state => state.branches.loadingNew)
    return (
    <Box width={"100%"} bgcolor={"#000"}  display={"flex"} flexDirection={"column"}  mt="-50%" >
    
      <Box mt="40%" >

        <Statistics  phone={phone} />
      </Box>
      <Grid container p="50px 0"  sx={{backgroundImage:'url(/images/office.JPG)'}} className='cover'>
      <Marquee gradient={false} style={{padding:'10px'}} >
        
      </Marquee>
            <Box  p={phone ?"10px" :"20px"} borderTop={"1px solid #D9D9D9"} borderBottom={"1px solid #D9D9D9"} width={phone? "100%":"92%"} m="auto">
            {loadingNew ? 
              <Skeleton variant="rectangular" width="100%" sx={{ bgcolor: 'grey.300',borderRadius:'50px'}}/>

            :
            <Marquee duration={20000} direction="right" gradient={false} style={{padding:'10px',width:'100%'}} >

            {news?.map((item,index)=>
            
              <h4  onClick={()=>{
                  window.scrollTo(0, 0);
                  item.LinkedEnabled == "1" && navigate(`/new/${item.Id}`)
              }} style={{color:'#fff',fontSize:'18px',cursor:'pointer',padding:'0 20px',borderLeft:'1px solid #fff'}} > {item.Title} </h4>
             
                )}
        
               </Marquee> }
            </Box>

       
        <Box display={"flex"} p="10px" flexDirection={"column"} justifyContent={"center"} alignItems={"center"} gap={3} width={"100%"}  >

            <Box display={"flex"} width={"100%"}  justifyContent={"space-around"} alignItems={"center"} gap={phone?5:1} flexDirection={phone?"column":"row"} flexWrap={"wrap"} p="10px" >
                
                <Box  data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-duration="1000">
                    <h2 style={{color:'#fff',width:'300px',textAlign:'center'}}>خدمـات جان اسنــک هر مشتری یک برنده</h2>
                </Box>
                <Box  mr={!phone&&"5%"}  position={"relative"} width={!phone&&"300px"} height={!phone&&"120px"} display={"flex"} alignItems={phone ? "center" :"flex-end"} justifyContent={"center"}>
                    <img src={phone?"/images/kabab.png":"/images/banner1.png"} alt=""  width={!phone&&"300px"} height={!phone&&"110px"} style={{borderRadius:'20px',position:!phone &&'absolute'}}  data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="100" />
                    {!phone&&<img src="/images/snaks.png" alt="" style={{position:'absolute'}} width={"200px"} height={"126px"}  data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="200"/>}
                </Box>
                <Box component={"div"} mr={!phone&&"8%"}  width={phone?"100%":'auto'} display={phone&&"flex"} justifyContent={phone&&"center"}  data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="100">
                    <Box bgcolor={" #EF7C00"} width="100px" borderRadius={"50%"} p="5px"  display={"flex"} justifyContent={"center"} alignItems={"center"}>
                        <img src="/images/plate.png" alt="" width="90px" data-aos="fade-up" data-aos-anchor-placement="top-bottom"  data-aos-delay="200" />
                    </Box>

                </Box>

            </Box>
            <Box display={"flex"} flexDirection={phone?"column" : "row"} justifyContent={"space-around"} gap={phone?5:2} width={"100%"} p="20px " > 
                <Box textAlign={"center"} width={phone ? '100%':"20%"}  data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="300">
                    <p style={{color:'#fff',textAlign:'center',lineHeight:3}}  > <h5 style={{fontSize:'1.1rem'}}>یک وعده خوشمزه و متفاوت</h5> زنجیره تامین یکپارچه جان، طعم و کیفیت یکسان در همه ی شعب   </p>
                </Box>
                <Box textAlign={"center"} width={phone ? '100%':"20%"} data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="400">
                    <p style={{color:'#fff',textAlign:'center',lineHeight:3}}  > <h5 style={{fontSize:'1.1rem'}}> کش بک خرید لحظه ای </h5> بازگشت آنی درصدی از خرید شما به کیف پول الکترونیک  </p>
                </Box>
                <Box textAlign={"center"} width={phone ? '100%':"20%"} data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="500" >
                    <h6 style={{color:'#fff',textAlign:'right',lineHeight:2,textAlign:'center'}} > <h5 style={{fontSize:'1.1rem'}}>فراتر از اسنک </h5> کیف پول متفاوت، برای نیازهای روزمره اعضای باشگاه مشتریان</h6>
                </Box>
            </Box>
        </Box>

      </Grid>
    </Box>
  )
}

export default StatisticsBox